import { twMerge } from 'tailwind-merge';
import MuiDialog, {
  type DialogProps as MuiDialogProps,
} from '@mui/material/Dialog';
import type { PaperProps } from '@mui/material';
import type { HtmlElementProps } from '@/types';
import DialogTitle from './DialogTitle';
import DialogBody from './DialogBody';
import DialogActions from './DialogActions';
import DefaultDialogActions from './DefaultDialogActions';
import { classes, styles } from './utils';

export type { DefaultDialogActionsProps } from './DefaultDialogActions';

export interface DialogProps extends HtmlElementProps {
  disableEscapeKeyDown?: boolean;
  disableBackdropClose?: boolean;
  paperProps?: PaperProps;
  onClose: () => void;
}

export default function Dialog({
  disableEscapeKeyDown = false,
  disableBackdropClose = false,
  paperProps = {},
  className,
  onClose,
  ...props
}: DialogProps) {
  const handleClose: MuiDialogProps['onClose'] = (e, reason) => {
    if (disableBackdropClose && reason === 'backdropClick') {
      return;
    }
    onClose();
  };

  return (
    <MuiDialog
      open
      disableEscapeKeyDown={disableEscapeKeyDown}
      disableRestoreFocus
      maxWidth={false}
      PaperProps={{
        ...paperProps,
        className: twMerge(classes.paper, paperProps.className),
      }}
      slotProps={{ backdrop: { sx: styles.backdrop } }}
      onClose={handleClose}>
      <div className={twMerge(classes.body, className)} {...props} />
    </MuiDialog>
  );
}

export { DialogTitle, DialogBody, DialogActions, DefaultDialogActions };
